import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService, EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnMaskParser } from "@bndes/bndes-ux4/bn-mask/bn-mask-parser";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Estado } from 'src/app/model/estado.model';
import { JanelaEnvioProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { STATUS_VALIDACAO, ValidacaoScr } from 'src/app/model/validacao-scr.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoHonraService } from "../solicitacao-honra/solicitacao-honra.service";
import { ValidacaoScrModule } from './validacao-scr.module';
import { ValidacaoScrService } from './validacao-scr.service';
import { TIPOS_VALIDACAO_ARQ_SCR } from 'src/app/model/validacao-scr.model';


@Component({
    selector: 'app-validacao-scr-pesquisa',
    templateUrl: './validacao-scr-pesquisa.component.html',
    styleUrls: ['./validacao-scr-pesquisa.component.scss'],
    standalone: false
})
export class ValidacaoScrPesquisaComponent implements OnInit {
 
  private pesquisaForm: UntypedFormGroup;
  private pesquisado = false; // usado no html
  private valoresPesquisaForm: any;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private validacoesScr: ValidacaoScr[];
  private tiposValidacao =  TIPOS_VALIDACAO_ARQ_SCR;
  private statusValidacaoOpcoes = STATUS_VALIDACAO;
  private codigoTipoValidacao: string;
  private atributosPaginacaoComponenteListagem: EntityPagedResult<ValidacaoScr>;
  private opcoesPaginacao: number[];
  private parametrosPesquisa:any = {};
  private statusValidacao: string = "Todos";
  private totalObjetosRetornados: number;
  cnpjUsuario: string;
  ehAgenteFinanceiro: boolean = false;
  operacao: any;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: ValidacaoScrService,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private fileUtils:FileUtilsService,
    protected messageService: MessageChannelService) {

      this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];

  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
      this.buscar(false, true)
  }


  ngOnInit() {
    this.valoresPesquisaForm = undefined;
    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario ? usuario.cnpj : null;

      this.opcoesPaginacao = [10, 15, 20];
      this.atributosPaginacaoComponenteListagem = {
        page: 1,
        pageSize: this.opcoesPaginacao[0],
        pages: undefined,
        count: undefined,
        list: undefined
      };

      this.pesquisaForm = this.createReactiveForm();

      this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
        this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];
        this.construirFormulario();
      });
    });
  }

  createReactiveForm(): UntypedFormGroup {

    const f =  this.formBuilder.group({
        agenteFinanceiro: null,
        janela: null,
        idValidacaoScr: null,
        statusValidacaoOpcoes:  null,
        idSolicitacaoHonra: [null, [Validators.pattern(/^[0-9]+$/), Validators.minLength(1)]],
        sistema:[
            {value: ''},
        ],
        idExternoOperacao:[
            {value: null, disabled: false}, [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]
        ],
        contrato:[
            {value: null, disabled: true}, 
        ],
        dataValidacaoInicio: null,
        dataValidacaoFim: null,
        tipoValidacao: null,
        excluirValidacoesVazias: 'S'
    });

    f.get('sistema').valueChanges.subscribe(sist => {
        const contrato = f.get('contrato');
        if (sist === 'CL') {
            contrato.disable();
            contrato.clearValidators();
        } else {
            contrato.enable();
            contrato.setValidators([Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]);
        }
        contrato.updateValueAndValidity();
    });

    return f;
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaSolicitacaoHonraForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

    var agenteDefault;

    if (this.ehAgenteFinanceiro) {
      agenteDefault = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
    }
    else {
      agenteDefault = this.valoresPesquisaForm.agenteFinanceiro ?
      this.agentesFinanceiros.filter(agente => agente.id === this.valoresPesquisaForm.agenteFinanceiro.id)[0]
      : null;
    }
 
    this.pesquisaForm.patchValue({
      agenteFinanceiro: agenteDefault,
      janela: this?.valoresPesquisaForm?.janela ? moment(this.valoresPesquisaForm.janela) : null,
      idValidacaoScr: this.valoresPesquisaForm.idValidacaoScr ? this.valoresPesquisaForm.idValidacaoScr : null, 
      statusValidacaoOpcoes: this.valoresPesquisaForm.statusValidacaoOpcoes ? this.valoresPesquisaForm.statusValidacaoOpcoes : null,
      sistema: this.valoresPesquisaForm.sistema ? this.valoresPesquisaForm.sistema : '',
      idExternoOperacao: this.valoresPesquisaForm.idExternoOperacao ? this.valoresPesquisaForm.idExternoOperacao : null, 
      contrato: this.valoresPesquisaForm.contrato ? this.valoresPesquisaForm.contrato: null,
      excluirValidacoesVazias: this.valoresPesquisaForm.excluirValidacoesVazias ? this.valoresPesquisaForm.excluirValidacoesVazias : 'S'
    });
 
    this.controlaCamposDesabilitados(this.valoresPesquisaForm);

    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.controlaCamposDesabilitados(novosValores);
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaSolicitacaoHonraForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<ValidacaoScr>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.pesquisado = false;
    const params: any = {};

    const agenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    if (agenteFinanceiro) {
        params.cnpjAgenteFinanceiro = agenteFinanceiro.cnpj;
    }

    const sistema = this.pesquisaForm.get('sistema').value;
    if (sistema) {
      params.sistema = sistema;
    }

    const idExternoOperacao = this.pesquisaForm.get('idExternoOperacao').value;
    if (idExternoOperacao && idExternoOperacao.trim()) {
      params.idExternoOperacao = idExternoOperacao.trim();
    }

    const contrato = this.pesquisaForm.get('contrato').value;
    if (contrato && contrato.trim()) {
      params.contrato = contrato.trim();
    }

    const idSolicitacaoHonra = this.pesquisaForm.get('idSolicitacaoHonra').value;
    if (idSolicitacaoHonra) {
      params.idSolicitacaoHonra = Number(idSolicitacaoHonra);
    }

    const dataJanela : Date = this.pesquisaForm.get('janela').value;
    if (dataJanela) {
      params.nomeJanela = this.datePipe.transform(dataJanela, 'MM/yyyy');
    }

    const dataValidacaoInicio: Date = this.pesquisaForm.get('dataValidacaoInicio').value;
    if(dataValidacaoInicio){
      params.dataValidacaoInicio = this.datePipe.transform(dataValidacaoInicio, 'yyyyMMdd');
    }

    const dataValidacaoFim: Date = this.pesquisaForm.get('dataValidacaoFim').value;
    if(dataValidacaoFim){
      params.dataValidacaoFim = this.datePipe.transform(dataValidacaoFim, 'yyyyMMdd');
    }

    const nomeTipoValidacao = this.pesquisaForm.get('tipoValidacao').value;
    this.codigoTipoValidacao = nomeTipoValidacao ? TIPOS_VALIDACAO_ARQ_SCR.filter(tipo => tipo.label === nomeTipoValidacao)[0].codigo : undefined;
    if (this.codigoTipoValidacao) {
      params.tipoValidacao = this.codigoTipoValidacao;
    }

    params.excluirValidacoesVazias = this.pesquisaForm.get('excluirValidacoesVazias').value;

    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));

    if(voltarPagina1){
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.validacoesScr, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    params.statusValidacao = this.statusValidacao;
    
    this.service.getValidacoesScr(params)
      .subscribe(response => {
        this.validacoesScr = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.loadingService.liberaTela();
         
        paginaVazia = Utils.verificaPaginaVazia(this.validacoesScr, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }
      });


  }

  private controlaCamposDesabilitados(novosValores) {
    if (novosValores.sistema == 'CL') {
      if (!this.pesquisaForm.get('contrato').disabled) {
        if (this.pesquisaForm.get('contrato').value != '') {
          this.pesquisaForm.get('contrato').setValue('');
        }
        this.pesquisaForm.get('contrato').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('contrato').disabled) {
        this.pesquisaForm.get('contrato').enable();
      }
    }

    if (novosValores.sistema == '89' || novosValores.sistema == '15') {
      if (!this.pesquisaForm.get('idExternoOperacao').disabled) {
        if (this.pesquisaForm.get('idExternoOperacao').value != '') {
          this.pesquisaForm.get('idExternoOperacao').setValue('');
        }
        this.pesquisaForm.get('idExternoOperacao').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('idExternoOperacao').disabled) {
        this.pesquisaForm.get('idExternoOperacao').enable();
      }
    }

    if (this.ehAgenteFinanceiro) {
      if (!this.pesquisaForm.get('agenteFinanceiro').disabled) {
        this.pesquisaForm.get('agenteFinanceiro').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('agenteFinanceiro').disabled) {
        this.pesquisaForm.get('agenteFinanceiro').enable();
      }
    }
  }

  compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }

  limpar() {
    this.pesquisado = false;
    this.pesquisaForm.reset({sistema: ''});
    this.validacoesScr = [];
  }
}
